module.exports = __webpack_public_path__ + "static/Logo-JRC-6dbd11b544d88ae3042899542903c1c3.png";